<ng-content />
@if (canResize) {
  <div cdkDrag cdkDragBoundary=".page-body"
    class="resizable-handle"
    (cdkDragEnded)="dragEnded($event)"
    (cdkDragMoved)="dragMoved($event)"
  (cdkDragStarted)="dragStarted()"></div>
  @if (sub$ | async) {
    <div class="resizable-triangle b-primary" [class.dragging]="isDragging"></div>
  }
}
